<h3>
    <a ng-click="viewDetails($event, item)">
        {{ item.name }}
    </a>
    <i ng-if="item.isHtml" class="fa fa-code badge" title="{{'notification.footer.isHtml'|translate}}"></i>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.description }}
</div>
